module.exports = __webpack_public_path__ + "static/media/send-button.5c106c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/send-button.png
// module id = 2122
// module chunks = 6